module.exports = __webpack_public_path__ + "static/media/img-04.aa8aeec9.jpg";